<script>
import { Captions } from '@/modules/analise-desmatamento/views/components';
import ReportMonitorModal from '@/modules/analise-desmatamento/views/components/report-monitor-modal';
import { mapActions, mapState } from 'vuex';
import { parseToFormat } from '@/utils/date';

export default {
    components: {
        Captions,
        ReportMonitorModal
    },
    data() {
        return {
            DEADLINE: 48,
            itemSelected: {},
            monitorModalVisible: false,
            analyzeModalVisible: false,
            status: {
                ENVIADO_PARA_ANALISE: this.$tc(
                    'analyze-deforestation.words.status_pending_analyze'
                ),
                EM_ANALISE: this.$tc(
                    'analyze-deforestation.words.status_in_analyze'
                ),
                ANALISE_FINALIZADA: this.$tc(
                    'analyze-deforestation.words.status_completed'
                )
            },
            type: {
                PROGRAMA_REGENAG: 'Regenag',
                CERTIFICACOES: 'Certificação'
            }
        };
    },
    computed: {
        ...mapState('analyzeDeforestationStore', ['reports']),
        ...mapState('analyzeDeforestationStore', ['filters']),
        statusColor() {
            return createdAt => {
                const timeRemaining = this.calculateTimeRemaining(createdAt);
                if (timeRemaining < 12) {
                    return 'var(--danger)';
                } else if (timeRemaining < 24) {
                    return 'var(--warning)';
                } else {
                    return 'var(--success)';
                }
            };
        },
        deadline() {
            return createdAt => {
                const createdDate = new Date(createdAt);
                return createdDate.setHours(
                    createdDate.getHours() + this.DEADLINE
                );
            };
        }
    },
    methods: {
        ...mapActions('analyzeDeforestationStore', ['fetchCars', 'changePage']),
        calculateTimeRemaining(createdAt) {
            const createdDate = new Date(createdAt);
            const now = new Date();
            const difference = Math.abs(now - createdDate);
            return this.DEADLINE - Math.ceil(difference / 36e5);
        },
        differenceInHours(createdAt, completedAt) {
            const createdDate = new Date(createdAt);
            const completedDate = new Date(completedAt);
            const difference = Math.abs(completedDate - createdDate);
            const result = this.DEADLINE - Math.ceil(difference / 36e5);
            return result > 0 ? `+${result}` : `${result}`;
        },
        monitor(item) {
            this.itemSelected = item;
            this.monitorModalVisible = true;
        },
        togglePage(page) {
            this.changePage(page - 1);
        },
        parseToFormat
    },
    watch: {
        filters: {
            handler(value) {
                const filters = { ...value, page: 0 };
                this.fetchCars(filters);
            },
            deep: true
        }
    },
    mounted() {
        this.fetchCars();
    }
};
</script>

<template>
    <div id="analyze-deforestation-list-page">
        <h3>{{ $tc('analyze-deforestation.messages.list_title') }}</h3>
        <div id="analyze-deforestation-list">
            <captions />
            <div v-if="reports.content.length" class="list" :key="listagemTableKey('reports-page', reports.content, reports.number + 1)">
                <div
                    v-for="report in reports.content"
                    :key="report.id"
                    class="list-item-wrapper"
                >
                    <div class="list-item">
                        <div
                            :style="{
                                backgroundColor: [
                                    'ENVIADO_PARA_ANALISE',
                                    'EM_ANALISE'
                                ].includes(report.situacao)
                                    ? statusColor(report.createdAt)
                                    : 'var(--primary)'
                            }"
                        >
                            <el-statistic
                                v-if="
                                    [
                                        'ENVIADO_PARA_ANALISE',
                                        'EM_ANALISE'
                                    ].includes(report.situacao)
                                "
                                ref="statistic"
                                format="HH:mm:ss"
                                :value="deadline(report.createdAt)"
                                time-indices
                                class="timer"
                            />
                            <span
                                v-if="report.situacao === 'ANALISE_FINALIZADA'"
                                class="timer"
                            >
                                {{
                                    differenceInHours(
                                        report.createdAt,
                                        report.completedAt
                                    )
                                }}h
                            </span>
                        </div>
                        <div>
                            <span
                                >{{
                                    $tc(
                                        'analyze-deforestation.words.territory'
                                    )
                                }}:</span
                            >
                            <span>
                                {{
                                    report.dadosAdicionais?.territorio || 'N/A'
                                }}
                            </span>
                        </div>
                        <div>
                            <span
                                >{{
                                    $tc('analyze-deforestation.words.farmers')
                                }}:</span
                            >
                            <template
                                v-if="
                                    report.dadosAdicionais?.produtores?.length
                                "
                            >
                                <span
                                    v-for="produtor in report.dadosAdicionais
                                        ?.produtores"
                                    :key="produtor"
                                >
                                    {{ produtor }}
                                </span>
                            </template>
                            <template v-else>
                                <span>N/A</span>
                            </template>
                        </div>
                        <div>
                            <span
                                >{{
                                    $tc('analyze-deforestation.words.locality')
                                }}:</span
                            >
                            <span>
                                {{
                                    report.dadosAdicionais?.localidade || 'N/A'
                                }}
                            </span>
                            <span
                                >{{
                                    $tc('analyze-deforestation.words.area')
                                }}:</span
                            >
                            <span> {{ report.dadosAdicionais?.area }} ha </span>
                        </div>
                        <div>
                            <span
                                >{{
                                    $tc('analyze-deforestation.words.status')
                                }}:</span
                            >
                            <span>{{ status[report.situacao] }}</span>
                        </div>
                        <div>
                            <span
                                >{{
                                    $tc('analyze-deforestation.words.type')
                                }}:</span
                            >
                            <span>{{ type[report.tipoSolicitacao] }}</span>
                        </div>
                        <div>
                            <span
                                >{{
                                    $tc('analyze-deforestation.words.datetime')
                                }}:</span
                            >
                            <span>{{
                                parseToFormat(
                                    report.createdAt,
                                    'DD/MM/YYYY às HH:mm'
                                )
                            }}</span>
                        </div>
                        <div style="margin: 0 10px">
                            <el-button
                                type="warning"
                                size="mini"
                                @click="monitor(report)"
                            >
                                <span style="color: white">{{
                                    $tc('analyze-deforestation.words.view')
                                }}</span>
                            </el-button>
                        </div>
                    </div>
                    <el-collapse>
                        <el-collapse-item
                            :disabled="!!!report.dadosAdicionais?.cars.length"
                        >
                            <template #title>
                                <div
                                    v-if="report.dadosAdicionais?.cars.length"
                                    class="list-item-cars"
                                >
                                    <span
                                        ><strong
                                            >{{
                                                $tc(
                                                    'analyze-deforestation.messages.cars_total'
                                                )
                                            }}:</strong
                                        >
                                        {{
                                            report.dadosAdicionais?.cars.length
                                        }}
                                    </span>
                                </div>
                                <span v-else class="list-item-cars">
                                    {{
                                        $tc(
                                            'analyze-deforestation.messages.cars_no_total'
                                        )
                                    }}
                                </span>
                            </template>
                            <span
                                v-for="produtor in report.dadosAdicionais?.cars"
                                :key="produtor"
                                class="list-item-cars"
                            >
                                {{ produtor }}
                            </span>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        :current-page="reports.number"
                        :page-size="reports.meta.size"
                        :total="reports.meta.totalElements"
                        layout="pager"
                        @current-change="togglePage"
                    />
                </div>
            </div>
            <div v-else id="no-cars">
                <el-button @click="this.fetchCars()">
                    {{ $tc('analyze-deforestation.messages.no_cars') }}
                </el-button>
            </div>
        </div>
        <report-monitor-modal
            v-if="monitorModalVisible"
            v-model="monitorModalVisible"
            :item="itemSelected"
        />
    </div>
</template>

<style lang="scss">
#analyze-deforestation-list-page {
    h3 {
        color: var(--primary);
        font-size: 16px;
        font-weight: 600;
        margin: 8px 0;
    }

    #analyze-deforestation-list {
        background-color: white;
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;
        min-height: 300px;

        .list {
            display: flex;
            flex-direction: column;

            .list-item-wrapper {
                background-color: #f5f5f5;
                border-radius: 8px;
                margin-bottom: 12px;
            }

            .list-item {
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                @media (max-width: 1024px) {
                    flex-direction: column;
                }

                div:first-child {
                    display: flex;
                    flex-direction: row;
                    box-sizing: border-box;
                    align-items: center;
                    min-width: 150px;
                    justify-content: center;
                    color: white;
                    border-top-left-radius: 8px;

                    @media (max-width: 1024px) {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                        border-top-right-radius: 8px;
                        min-width: 100%;
                        min-height: 80px;
                    }

                    &::after {
                        display: none;
                    }
                }

                div {
                    position: relative;
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    padding: 10px;
                    box-sizing: border-box;
                    justify-content: flex-start;
                    @media (max-width: 1024px) {
                        justify-content: flex-start;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 25%;
                        height: 50%;
                        width: 1px;
                        background-color: #dcdfe6;
                        @media (max-width: 1024px) {
                            display: none;
                        }
                    }

                    span:nth-child(odd) {
                        color: var(--primary);
                        font-weight: bold;
                        font-size: 14px;
                    }

                    span:last-child {
                        color: var(--dark);
                        font-size: 14px;
                        text-wrap: wrap;
                        @media (max-width: 1024px) {
                            word-break: break-all;
                        }
                    }
                }

                div:last-child {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;

                    &::after {
                        display: none;
                    }
                }
            }

            .list-item-cars {
                padding: 0 10px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;

                span {
                    padding: 0;
                    margin: 0;
                }
            }

            .list-pagination {
                display: flex;
                justify-content: flex-end;
                margin-top: 20px;
            }
        }
    }

    .timer {
        color: white !important;
    }

    #no-cars {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        font-size: 16px;
        color: var(--dark);
    }

    .el-collapse {
        border-bottom: none !important;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    .el-collapse-item__wrap {
        background-color: transparent !important;
        border-bottom: none !important;
    }

    .el-collapse-item__header {
        background-color: transparent !important;
        border-bottom: none !important;
    }
}

#analyze-deforestation-list-page
    #analyze-deforestation-list
    .list
    .list-item
    div:last-child {
    justify-content: center;
    padding: 0;
}
</style>
